



























import 'reflect-metadata'
import { Component, Watch, Mixins } from 'vue-property-decorator'
import Loader from '@/components/misc/Loader.vue'
// import EVMAddressSummary from '@/components/Address/EVMAddressSummary.vue'
import HTTPError from '@/components/misc/HTTPError.vue'
import { TransactionsGettersMixin } from '@/store/modules/transactions/transactions.mixins'
import { getMappingForType } from '@/store/modules/transactions/maps'

@Component({
    components: {
        Loader,
        // EVMAddressSummary,
        HTTPError,
    },
    filters: {
        getType: getMappingForType,
    },
})
export default class EVMAddressPage extends Mixins(TransactionsGettersMixin) {
    loading = false
    breadcrumbs: any = [
        {
            text: 'Home',
            disabled: false,
            href: '/',
        },
        {
            text: 'Addresses',
            disabled: false,
            href: '/', //TODO
        },
        {
            text: 'Detail',
            disabled: true,
            href: '',
        },
    ]

    @Watch('addressId')
    onaddressIdChanged() {
        this.getData()
    }

    @Watch('assetsLoaded')
    onAssetsLoaded() {
        this.getData()
    }

    created() {
        this.getData()
    }

    get assetsLoaded() {
        return this.$store.state.assetsLoaded
    }

    get addressId(): string {
        return this.$route.params.id
    }

    // get address() {
    // return this.getEVMAddress()
    // }

    getData(): void {
        this.loading = true
        // if (this.assetsLoaded) {
        //     this.$store
        //         .dispatch('Address/getEVMAddress', {
        //             hash: this.addressId,
        //         })
        //         .then(() => {
        //             this.loading = false
        //         })
        //         .catch((err) => {
        //             console.log(err)
        //         })
        // }
    }
}
